
import { Ray3}  from "./ray_types";
import CollisionService from "./collision_service";
import { CollisionVolume } from "./collision_volume";
import { point_on_ray } from "./ray_math";

const RAY_EPSILON = 0.000001;

export type ReticleHit = {
  point: Float32Array;
  distance: number;
  kind: "ground" | "nav";
  volume: CollisionVolume | null;
};


export function intersect_ground_y0(ray: Ray3): ReticleHit | null {
  const dy = ray.direction[1];
  if (Math.abs(dy) < RAY_EPSILON) return null;

  const t = -ray.origin[1] / dy;
  if (t < 0) return null;

  return {
    point: point_on_ray(ray, t),
    distance: t,
    volume: null,
    kind: "ground",
  };
}

export function find_reticle_hit(
  ray: Ray3,
  collision_service: CollisionService
): ReticleHit | null {
  let best = intersect_ground_y0(ray);

  const nav_hit = collision_service.raycastVolumes(ray, "nav");
  if (nav_hit && (!best || nav_hit.distance < best.distance)) {
    best = {
      point: nav_hit.point,
      distance: nav_hit.distance,
      volume: nav_hit.volume,
      kind: "nav",
    };
  }

  return best;
}

